var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-flow-type-text"},[(_vm.type === 'text')?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('el-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.onInput}},_vm._l((_vm.list),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }